var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 17.3947C4.44649 15.3302 7.08918 14.0614 10 14.0614C12.9108 14.0614 15.5535 15.3302 17.5 17.3947M13.75 6.97803C13.75 9.0491 12.0711 10.728 10 10.728C7.92893 10.728 6.25 9.0491 6.25 6.97803C6.25 4.90696 7.92893 3.22803 10 3.22803C12.0711 3.22803 13.75 4.90696 13.75 6.97803Z",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.63a5cb0b19673febd5adf8e4b646dae7.svg";
export { ForwardRef as ReactComponent };